import { useEffect, useState } from "react";
import { Modal } from "@mui/joy";
import { Box, Button, Grid, TextField, Typography, Table } from "@mui/material";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useGetEmployeeDetailsQuery } from "../../services/vendor/VendorApi";
import { useGetEmployeeListNewQuery } from "../../services/invoices/InvoiceApiSlice";

const EmployeeModal = ({ isOpen, setIsOpen, setSelectedEmp }) => {
  const [empList, setEmpList] = useState([]);
  const [empFilter, setEmpFilter] = useState([]);
  const [searchName, setSearchName] = useState("");
  const [searchCode, setSearchCode] = useState("");

  const { data: list }: any = useGetEmployeeDetailsQuery(undefined, { refetchOnMountOrArgChange: true });
  const {
    data: employeeData,
    isLoading: isEmployeeDataLoading,
    isError: isEmployeeDataError,
    error: employeeDataError,
  } = useGetEmployeeListNewQuery(null);



  useEffect(() => {
    if (employeeData) {
      setEmpList([...employeeData?.d?.results]);
      setEmpFilter([...employeeData?.d?.results]);

    }
  }, [employeeData, isOpen]);

  // useEffect(() => {
  //   if (list?.length > 0) {
  //     setEmpList([...list]);
  //     setEmpFilter([...list]);

  //   }
  // }, [list, isOpen]);

  const handleSearchEmp = () => {
    if (searchName?.trim() === "" && searchCode?.trim() === "") {
      setEmpFilter(empList);
    } else {
      const filter = empList.filter(
        (item) =>
          (item.ename.toLowerCase().includes(searchName.toLowerCase()) && searchName !== "") ||
          (item.pernr.toLowerCase().includes(searchCode.toLowerCase()) && searchCode !== "")
      );
      setEmpFilter([...filter]);
    }
  };
  const handleClickRow = (empName, empCode, empUName) => {
    setSelectedEmp({ empName, empCode, empUName });
    setEmpFilter([]);
    setSearchCode("");
    setSearchName("");
  };


  return (
    <Modal open={isOpen} onClose={() => setIsOpen(false)} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description" className="custom-modal">
      <Box sx={style}>
        <Typography id="modal-modal-title" component="h2">
          Search Employee
        </Typography>
        <Box id="modal-modal-description" sx={{ mt: 2 }}>
          <Grid container spacing={2}>
            <Grid size={5}>
              <TextField
                id="outlined-basic"
                label="Employee Code"
                variant="outlined"
                style={{ width: "100%" }}
                value={searchCode}
                onChange={(event) => setSearchCode(event.target.value)}
                size="small"
              />
            </Grid>
            <Grid size={5} style={{ textAlign: "center" }}>
              <TextField
                size="small"
                id="outlined-basic"
                label="Employee Name"
                variant="outlined"
                style={{ width: "100%" }}
                value={searchName}
                onChange={(event) => setSearchName(event.target.value)}
              />
            </Grid>
            <Grid size={2}>
              <Button variant="contained" size="small" className="goBtn-emp-search" onClick={() => handleSearchEmp()}>
                Go
              </Button>
            </Grid>
          </Grid>
          <br />

          {empFilter.length > 0 && (
            <TableContainer component={Paper} style={{ maxHeight: "350px" }}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow style={{ background: "#f0f4f8" }}>
                    <TableCell align="center">Employee Code</TableCell>
                    <TableCell align="center">Employee Name</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {empFilter?.map((row) => (
                    <TableRow
                      onClick={() => handleClickRow(row.ename, row.pernr, row.username)}
                      key={"yuhj" + row.EMP_ID}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                      className="row-hover"
                    >
                      <TableCell align="center">{row.pernr}</TableCell>
                      <TableCell align="center">{row.ename}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default EmployeeModal;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs: "90%",
    sm: "80%",
    md: 500,
  },
  bgcolor: "#fff",
  border: "0px solid #000",
  boxShadow: 24,
  p: 4,
};
